import { NextPage, NextPageContext } from 'next';
import React from 'react';

import ListingPhotosIndex from '@/components/route/listing/ListingIndex/ListingPhotosIndex';
import { getAvailability } from '@/redux/modules/availability';
import { getListing } from '@/redux/modules/listing';
import { getQuote } from '@/redux/modules/quote';
import { redirectToSearch, withRedirectToSearch } from '@/services/redirectToSearch';
import { IStore } from '@/utility/redux/store';
import { parseRentalIdFromSlug } from '@/utility/routes';

const ListingPhotos: NextPage = () => {
  return <ListingPhotosIndex isCampsite />;
};

ListingPhotos.getInitialProps = withRedirectToSearch(
  async ({
    res,
    query,
    pathname,
    reduxStore,
    locale,
  }: NextPageContext & { reduxStore: IStore }) => {
    const { slug } = query;
    const rentalId = (slug && parseRentalIdFromSlug(slug)) || '';
    const state = reduxStore.getState();
    const hasListingData = state.listing.data?.id === Number(rentalId);
    const hasAvailability = hasListingData && state.availability.isFetched;
    const hasQuote = hasListingData && typeof state.quote.data?.id !== 'undefined';

    if (rentalId && !hasListingData) {
      const listing = await reduxStore.dispatch(getListing(rentalId, locale));
      const listingSlug = listing?.slug;

      // Force redirect if this is a non-campsite (e.g. RV listing)
      if (listingSlug && !listingSlug.startsWith('/campsite-rental')) {
        return redirectToSearch({ res, query });
      }
      if (listing?.hidden || listing?.has_been_published === false) {
        return redirectToSearch({ res, query }, pathname);
      }
      if (!hasQuote) await reduxStore.dispatch(getQuote());
      if (!hasAvailability) await reduxStore.dispatch(getAvailability(rentalId));
    }

    return { query, pathname, props: {} };
  },
);

export default ListingPhotos;
